// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cwb__toolbar__button {
  color: #444444;
  background-color: transparent;
  border: none;
  border-radius: 6px;

  padding: 0;

  width: 28px;
  height: 28px;

  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  overflow: hidden;

  transition: background-color 0.2s ease;
}

.cwb__toolbar__button:hover {
  background-color: #d0d0d0;
  outline: none;
}

.cwb__toolbar__button.active {
  background-color: rgb(197, 197, 222);
  color: rgb(62, 62, 150);
}

.cwb__toolbar__button > * {
  width: 160%;
  height: 160%;
}


.cwb__toolbar__button__wrapper {
    position: relative;
    display: inline-block;
}

.cwb__toolbar__button__panel {
    position: absolute;
    top: 0;
    left: 100%;
    margin-left: 16px;
}
/* Cuando hay poco height, el dropdown baja en vez de ir a la derecha */
@media (max-height: 500px) {
  .cwb__toolbar__button__panel {
    top: 100%;      /* Justo debajo del botón */
    left: 0;        /* Alineado a la izquierda */
    margin-left: 0;
    margin-top: 8px; /* Separación visual */
  }
}


.cwb__toolbar__tooltip {
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 8px;
  background-color: #333;
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 13px;
  white-space: nowrap;
  z-index: 1000;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.cwb__toolbar__tooltip__arrow {
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 5px solid #333;
}

/* 🔽 Cuando la pantalla es baja (la barra es horizontal) */
@media (max-height: 500px) {
  .cwb__toolbar__tooltip {
    left: 50%;
    top: 100%;
    transform: translateX(-50%);
    margin-left: 0;
    margin-top: 8px;
  }

  .cwb__toolbar__tooltip__arrow {
    right: auto;
    left: 50%;
    top: 0;
    transform: translateX(-50%) translateY(-100%);
    border-right: none;
    border-top: none;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #333;
  }
}

`, "",{"version":3,"sources":["webpack://./react/features/whiteboard/custom-ui/styles/toolbar-button.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;;EAElB,UAAU;;EAEV,WAAW;EACX,YAAY;;EAEZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,gBAAgB;;EAEhB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,iBAAiB;AACrB;AACA,uEAAuE;AACvE;EACE;IACE,SAAS,OAAO,2BAA2B;IAC3C,OAAO,SAAS,4BAA4B;IAC5C,cAAc;IACd,eAAe,EAAE,sBAAsB;EACzC;AACF;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA,2DAA2D;AAC3D;EACE;IACE,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,SAAS;IACT,MAAM;IACN,6CAA6C;IAC7C,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,mCAAmC;IACnC,6BAA6B;EAC/B;AACF","sourcesContent":[".cwb__toolbar__button {\n  color: #444444;\n  background-color: transparent;\n  border: none;\n  border-radius: 6px;\n\n  padding: 0;\n\n  width: 28px;\n  height: 28px;\n\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  overflow: hidden;\n\n  transition: background-color 0.2s ease;\n}\n\n.cwb__toolbar__button:hover {\n  background-color: #d0d0d0;\n  outline: none;\n}\n\n.cwb__toolbar__button.active {\n  background-color: rgb(197, 197, 222);\n  color: rgb(62, 62, 150);\n}\n\n.cwb__toolbar__button > * {\n  width: 160%;\n  height: 160%;\n}\n\n\n.cwb__toolbar__button__wrapper {\n    position: relative;\n    display: inline-block;\n}\n\n.cwb__toolbar__button__panel {\n    position: absolute;\n    top: 0;\n    left: 100%;\n    margin-left: 16px;\n}\n/* Cuando hay poco height, el dropdown baja en vez de ir a la derecha */\n@media (max-height: 500px) {\n  .cwb__toolbar__button__panel {\n    top: 100%;      /* Justo debajo del botón */\n    left: 0;        /* Alineado a la izquierda */\n    margin-left: 0;\n    margin-top: 8px; /* Separación visual */\n  }\n}\n\n\n.cwb__toolbar__tooltip {\n  position: absolute;\n  left: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  margin-left: 8px;\n  background-color: #333;\n  color: #fff;\n  padding: 6px 10px;\n  border-radius: 4px;\n  font-size: 13px;\n  white-space: nowrap;\n  z-index: 1000;\n  pointer-events: none;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n}\n\n.cwb__toolbar__tooltip__arrow {\n  position: absolute;\n  right: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-right: 5px solid #333;\n}\n\n/* 🔽 Cuando la pantalla es baja (la barra es horizontal) */\n@media (max-height: 500px) {\n  .cwb__toolbar__tooltip {\n    left: 50%;\n    top: 100%;\n    transform: translateX(-50%);\n    margin-left: 0;\n    margin-top: 8px;\n  }\n\n  .cwb__toolbar__tooltip__arrow {\n    right: auto;\n    left: 50%;\n    top: 0;\n    transform: translateX(-50%) translateY(-100%);\n    border-right: none;\n    border-top: none;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-bottom: 5px solid #333;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
